// src/shared/categories.js

export const CATEGORY_LAYERS = {
  EMOTIONAL_SUPPORT: "EMOTIONAL_SUPPORT",
  RELATIONSHIPS: "RELATIONSHIPS",
  LIFE_CHALLENGES: "LIFE_CHALLENGES",
  HIGH_RISK: "HIGH_RISK",
  SPIRITUAL: "SPIRITUAL",
};

export const CATEGORY_DESCRIPTIONS = {
  // Layer-based fallbacks
  EMOTIONAL_SUPPORT: "Anxiety, stress, loneliness, just want to talk",
  RELATIONSHIPS: "Relationships, parenting, marriage, bullying",
  LIFE_CHALLENGES: "Career, finance, education, business",
  SPIRITUAL: "Self-discovery, spiritual evolution",
  HIGH_RISK: "Specialized support for sensitive situations",

  // ID-based specific descriptions
  SUICIDE_PREVENTION: "Suicide prevention and crisis support",
  ADDICTION: "Addiction and substance abuse recovery",
  TRAUMA: "Trauma recovery and abuse support",
};

export const CATEGORIES = [
  {
    id: "EMOTIONAL_SUPPORT",
    label: "Emotional Support",
    layer: CATEGORY_LAYERS.EMOTIONAL_SUPPORT,
  },
  {
    id: "RELATIONSHIPS",
    label: "Relationships & Social Life",
    layer: CATEGORY_LAYERS.RELATIONSHIPS,
  },
  {
    id: "LIFE_CHALLENGES",
    label: "Life Challenges",
    layer: CATEGORY_LAYERS.LIFE_CHALLENGES,
  },
  {
    id: "HIGH_RISK",
    label: "High Risk (Strict)",
    layer: CATEGORY_LAYERS.HIGH_RISK,
  },
  {
    id: "SPIRITUAL",
    label: "Spiritual & Personal Growth",
    layer: CATEGORY_LAYERS.SPIRITUAL,
  },
];
